import {tCountry} from "./countriesMap";
import OTelInput from "./OTelInput";

const countryChooser = function (el: any, obj: OTelInput) {
	let $i   = $("<i class=\"o-tel-input-flag flag\"></i>"),
		$ele = $(el).empty().append($i);

	obj.onChange(function (country: tCountry) {
		$i.attr("class", "o-tel-input-flag flag " + country.cc2.toLowerCase());
	});

	$ele.off(".o-tel-chooser")
		.on("click.o-tel-chooser", function () {
			let options     = obj.getOptions(),
				allowed_len = options.allowedCountries().length;

			if (allowed_len === 1) {
				return;
			}

			let $chooser = $(obj.getCountriesAsHtml()),
				cc2      = obj.getCurrentCountry().cc2,
				y        = $chooser.appendTo("body")
								   .find(".o-tel-chooser-cont")
								   .on("click", function (e) {
									   if (e.target === this) {
										   $chooser.remove();
										   $ele.trigger("o-tel-chooser-event", ['cancel', obj.getCurrentCountry()]);
									   }
								   })
								   .find("li")
								   .on("click", function () {
									   obj.setCountry($(this).data("o-tel-cc2"));
									   $ele.trigger("o-tel-chooser-event", ['change', obj.getCurrentCountry()]);
									   $chooser.remove();
								   }).filter("[data-o-tel-cc2=" + cc2 + "]").position().top || 0;
			$chooser.find("ul").scrollTop(y);
		});

};

export default countryChooser;